export default __webpack_public_path__ + "static/media/menu.2b0d9b27.svg";